window.layoutTrads;

window.staffTable = {
	init: function(){
		$('.tableSort').tablesorter({textExtraction:function(node){return $(node).find('input').val();}});
	}
};

window.PrefsLogs = {

	init : function(){
		MyTabs.initVertical('prefsMailNotifVerticalTab');
	},

	// use this for mail notifications form
	resetAllLog:function(){

		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Désactiver les notifications"),
			buttons		: [
				{
					text : Loc.g("Non"),
					'class' : 'btn btn-default',
					click : function(){
						$('#toggleActivationNotification').toggleClass('form-toggle-on', true);
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					click : function(){
						MyFacture.post('prefsNotifs', {'action':'resetmailnotifications'}, function(){
							location.reload();
						});

					}
				}
			]
		};

		MyWindow.alert(Loc.g('Êtes vous sur de vouloir désactiver l’ensemble des notifications ?'), options);

	},

	// use this for mail notifications form
	restoreDefaultLog: function(){
		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Restaurer les valeurs par défaut"),
			buttons		: [
				{
					text : Loc.g("Non"),
					click : function(){
						$(this).dialog("close");
						$('#toggleActivationNotification').toggleClass('form-toggle-off', true);
						$('#toggleActivationNotification').toggleClass('form-toggle-on', false);
					}
				},
				{
					text : Loc.g("Oui"),
					click : function(){
						MyFacture.post(
							'prefsNotifs',
							{
								'action':'restoremailnotifications'
							},
							function(){
								Utils.reload();
							}
						);
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Êtes vous sur de vouloir restaurer les notifications avec les valeurs par défaut ?'), options);

	},

	// use this for mail notifications form
	toggleLog: function(me, logId, logType){

		var logStatus;
		if (me.hasClass('on')){
			me.removeClass('on').addClass('off');
			me.find('i').attr('class', 'fa fa-toggle-off');
			logStatus = "off";
		} else {
			me.removeClass('off').addClass('on');
			me.find('i').attr('class', 'fa fa-toggle-on');
			logStatus = "on";
		}

		var nbActivatedNotifsForType = $('.logRow_'+logType+ ' .logToggler.on').length;
		$('.logTitle_'+logType+ ' .logNbEnabled').html(nbActivatedNotifsForType);

		var totalActivatedForContent	= $('.logRow_'+logType).closest('.content-block').find('.logToggler.on').length;
		var totalActivateId				= $('.logRow_'+logType).closest('.content-block').attr('id').split('_')[1];

		$('#'+totalActivateId).find('.totalLogEnabled').html(totalActivatedForContent);

		if (totalActivatedForContent > 0){
			$('#'+totalActivateId).find('.label-small').removeClass('label-info').addClass('label-success');
		} else {
			$('#'+totalActivateId).find('.label-small').removeClass('label-success').addClass('label-info');
		}

		// when user in
        MyFacture.post(
            'prefsNotifs&action=mailnotificationsRecord',
            {
                logId: logId,
                logType: logType,
                logStatus:logStatus
            },
            function(data){},
            "json"
        );

		var nbTotalNotif = 0;
		$( "span[class='totalLogEnabled']" ).each(function( index ) {
			nbTotalNotif += parseInt($(this).text());
		});

		$('#toggleActivationNotification').toggleClass('form-toggle-on', nbTotalNotif > 0);
		$('#toggleActivationNotification').toggleClass('form-toggle-off', nbTotalNotif == 0);

	},

	changeNotifType : function (currentValue) {
		MyFacture.post(
			'prefsNotifs&action=changeNotifType',
			{
				value : currentValue.val()
			},
			function(data, result){
				if (data.status == 'ok') {
					Push.success(Loc.g("La modification a bien été prise en compte"));
				} else {
					Push.error(Loc.g("Une erreur est survenue, la modification n'a pas été prise en compte"));
				}
			},
			"json"
		);
	},

	activateNotif : function (object) {
		if (object.hasClass('form-toggle-on')) {
			PrefsLogs.resetAllLog();
		} else {
			PrefsLogs.restoreDefaultLog();
		}
		PrefsLogs.saveNotifStatus();
	},

	saveNotifStatus : function (status) {
		MyFacture.post(
			'prefsNotifs&action=saveNotifStatus',
			{
				value : status
			},
			function(data){},
			"json"
		);
	}

};

window.PrefsShipping = {

	changeBillingMethod: function(me){

		var selected = me.val();

		var unitSymbol = "";

		switch (selected){
			case "weight":
				unitSymbol = $('#shippingAdvancedForm #rangeUniWteight').html();
				break;
			case "price":
				unitSymbol = $('#shippingAdvancedForm #rangeUnitPrice').html();
				break;
		}

		$('#shippingAdvancedForm #baseUnitInput .input-addon').html(unitSymbol);
		$('#shippingAdvancedForm .minRange, #shippingAdvancedForm .maxRange').find('.input-addon').html(unitSymbol);

	},

	removeRangeToAdvancedSetting: function(me){
		var index = me.closest('td').index();
		// Substract 1 to deal with th
		index--;

		$('.shippingRangesContainer table tr').each(function(){
			$(this).find('td:eq('+index+')').remove();
		});

	},

	removeCountryToAdvancedSetting: function(me){
		me.closest('tr').remove();
	},

	addCountryToAdvancedSetting: function(){

		var country		= $('#shippingAdvForm_addCountriesList').val();
		var countryName = $('#shippingAdvForm_addCountriesList option[value="'+country+'"]').html();

		if ($('.shippingRangesContainer tr[country="'+country+'"]:visible').length > 0){
				MyWindow.alert(Loc.g('Ce pays est déjà dans la liste'), {type:'warning'});
		} else {

			var nbInputToAdd = $('.shippingRangesContainer table tr:first').find('th:visible, td:visible').length;

			var newHtml ='<tr country="'+country+'">';

			newHtml +=	'<th class="shippingAdvFormTabStrong"><img class="mr-2" src="ressources/public/img/flags/'+country.toLowerCase()+'.png" />'+country.name+' <a href="javascript:;" onClick="PrefsShipping.removeCountryToAdvancedSetting($(this));"><i class="fa fa-trash-o fright"></i></a></th>';

			for (i = 2; i<=nbInputToAdd; i++){

				var id		= "shippingAdvForm_dynPrice_"+(i-1)+"_countries_"+country;
				var name	= "shippingAdvForm_dynPrice["+(i-1)+"][countries]["+country+"]";

				var basePricInput = $('#basePriceInput').clone();
				basePricInput.removeAttr('id').find('input').attr('id', id).attr('name', name);

				newHtml +=	'<td>';
				newHtml +=		'<div class="form-group">' +basePricInput.html() + "</div>";
				newHtml +=	'</td>';

			}

			newHtml +=	'</tr>';

			$('.shippingRangesContainer table').append(newHtml);
			$('.shippingRangesContainer table tr:last input:first').focus();
			MyFacture.customForm("#shippingAdvancedForm");
		}


	},

	addRangeToAdvancedSetting: function(){

		var lastMinRange	= $($('.shippingRangesContainer table tr:eq(1) td.minRange:visible:last input')[0]).val();
		var lastMaxRange	= $($('.shippingRangesContainer table tr:eq(2) td.maxRange:visible:last input')[0]).val();
		var position		= $('.shippingRangesContainer table tr:first').find('th:visible,td:visible').length;

		if (lastMinRange == "" || lastMaxRange == ""){
			MyWindow.alert(Loc.g('Veuillez compléter le dernier seuil avant dans ajouter un nouveau.'), {type:'warning'});
		} else {

			$('.shippingRangesContainer table tr:first').append('<td class="shippingAdvFormTabDelete">'+Loc.g('Seuil')+' '+position+' <a href="javascript:;" onClick="PrefsShipping.removeRangeToAdvancedSetting($(this))"><i class="fa icon-trash"></i></a></td>')

			$('.shippingRangesContainer table tr').not(':first').each(function(index){

				if (!$(this).hasClass('shippingCountryRow')){

					var value		= "";
					var id			= "";
					var name		= "";
					var cssClass	= "";
					var baseInput	= {};
					var nbTd	= $(this).find('td').length;

					switch (index){
						case 0:
							value		= $(this).next().find('td:eq('+(nbTd-1)+') input').val();
							id			= "shippingAdvForm_dynPrice_"+(nbTd+1)+"_minRange";
							name		= "shippingAdvForm_dynPrice["+(nbTd+1)+"][minRange]";
							cssClass	= "minRange";
							baseInput	= $('#baseUnitInput').clone();
							break;
						case 1:
							id			= "shippingAdvForm_dynPrice_"+(nbTd+1)+"_maxRange";
							name		= "shippingAdvForm_dynPrice["+(nbTd+1)+"][maxRange]";
							cssClass	= "maxRange";
							baseInput	= $('#baseUnitInput').clone();
							break;
						default:
							var country = $(this).attr('country');
							id			= "shippingAdvForm_dynPrice_"+(nbTd+1)+"_countries_"+country;
							name		= "shippingAdvForm_dynPrice["+(nbTd+1)+"][countries]["+country+"]";
							baseInput	= $('#basePriceInput').clone();
							break;
					}

					baseInput.find('input').attr('id', id).attr('name', name).attr('value',value);

					var newHtml =	'<td class="'+cssClass+'">';
						newHtml +=		'<div class="form-group">' + baseInput.html() + "</div>";
						newHtml +=	'</td>';

					var newEl = $(this).append(newHtml);

				}
			});
			MyFacture.customForm("#shippingAdvancedForm");
			$('.shippingRangesContainer table tr:eq(2) td.maxRange:visible:last input').focus();
		}

	},

	advancedSettingsForm: function(shippingId){


		var options = {
			title	: Loc.g('Paramètres avancés du Transporteur'),
			width: 1000,
			buttons	: [
                {
                    text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
                },
                {
				text : Loc.g("Enregistrer"), click : function(){
					$("#shippingAdvancedForm").submit();
				}}
				],
			callback	: function(){
				PrefsShipping.prepareShippingAdvancedForm();
			}
		};

		MyWindow.load("catalogPreferences", {action:"shippingAdvancedForm", shippingId:shippingId,}, options);

	},

	prepareShippingAdvancedForm: function(){

		var formId = "shippingAdvancedForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "shippingAdvancedForm");
			if (formIsOk){
				MyWindow.close();
			}

		}, dataType:"json"};
		var data = {action: 'recordShippingAdvancedForm'};
        MyForm.prepare(formId, "catalogPreferences&"+$.param(data), options, true);
		MyFacture.initEvent();


		$('#shippingAdvForm_dynamicPrice').on('change', function(event, ui){

			var value = $(this).val();

			if (value == "Y"){
				$('#shippingAdvancedForm .dynamicPrice').show();
				MyFacture.customForm('#shippingAdvancedForm');
			} else {
				$('#shippingAdvancedForm .dynamicPrice').hide();
			}
		});
	}

};

window.PrefsGroup = {

	addStaffToGroup : function(staffid, groupid){
		console.log(item);

		MyFacture.post(
			'prefsAccount',
			{
				action : 'addstafftogroup',
				staffid: staffid,
				groupid: groupid
			},
			function(data){

			},
			"json"
		);
	},

	init: function(){

		$('.addStaffForm').on('submit', function(e){

			var formData = $(this).serializeArray();

			var params = [];
			for(var i in formData){
				params[formData[i]['name']] = formData[i]['value'].replace('staff_', '');
			}

			if(params.staffid !== undefined && params.groupid !== undefined){

				if($('#group_'+params.groupid).find('#staff_'+params.staffid).length == 0){
					$.ajax({
						type	: 'POST',
						url		: '/?_f=prefsAccount&action=addstafftogroup',
						data	: $(this).serializeArray(),
						dataType: 'json',
						success	: function(data){

							var $tr = $('<tr id="staff_'+data.staff.id+'"></tr>');
							$tr.append('<td>'+data.staff.avatarFormatted+'</td>');
							$tr.append('<td>'+data.staff.name+'</td>');
							$tr.append('<td class="aright"><a href="javascript:;" onclick="PrefsGroup.removeStaffFromGroup($(this));"><i class="fa icon-trash"></i></a></td>');


							var $groupContainer = $("#group_"+params.groupid);

							$groupContainer.find('.groupstaffs table').append($tr);
							if(!$groupContainer.find('.placeholder').hasClass('hidden')){
								$groupContainer.find('.placeholder').addClass('hidden');
							}
						}
					});
				}else{
					MyWindow.alert(Loc.g('Le collaborateur sélectionné est déjà dans le groupe'), {type : 'warning'});
				}
			}

			e.preventDefault();
		});

	},

	removeStaffFromGroup: function(me){
		var $staffContainer = me.closest('tr');
		var groupid			= $staffContainer.closest('li').attr('id');
		var staffid			= $staffContainer.attr('id');

		MyFacture.post('prefsAccount&action=deleteStaffFromGroup', {staffid: staffid, groupid: groupid}, function(data){

			var $groupStaffsContainer = $staffContainer.closest('table');
			$staffContainer.remove();

			groupid = groupid.replace('group_', '');


			if($("table tr", "#group_"+groupid).length == 0){
				console.log($("#group_"+groupid).find('.placeholder'));
				$("#group_"+groupid).find('.placeholder').removeClass('hidden');
			}

		}, "json");

	},

	deleteGroup: function(groupId){
		var msg =  Loc.g("Supprimer ce groupe ?");
		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Supprimer le groupe"),
			buttons		: [
				{text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
				{text : Loc.g("Oui"), click : function(){PrefsGroup.doDeleteGroup(groupId);}}
			]
		};
		MyWindow.alert(msg, options);
	},

	doDeleteGroup: function(groupid){

		MyFacture.post('prefsAccount&action=deleteGroup', {groupId: groupid}, function(data){
			Utils.reload();
		}, "json");

	},

	editGroup: function(groupId){

		var options = {
			title	: Loc.g("Modification du groupe"),
			height: 200,
			width : 600,
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Enregistrer"), click : function(){$("#groupForm").submit();}}
			],
			callback	: function(){PrefsGroup.prepareGroupForm();}
		};

		var params = {action:"groupForm", groupId: groupId};
		MyWindow.load("prefsAccount", params, options);
	},

	addGroup: function(){

		var options = {
			title	: Loc.g("Ajouter un groupe"),
			height: 200,
			width : 600,
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Enregistrer"), click : function(){$("#groupForm").submit();}}
			],
			callback	: function(){PrefsGroup.prepareGroupForm();}
		};

		var params = {action:"groupForm"};
		MyWindow.load("prefsAccount", params, options);

	},

	prepareGroupForm: function(){

		var formId = "groupForm";
		var options = {
				success:function(data){
					var formIsOk = MyForm.processJson(data, "groupForm");
					if(formIsOk){
					Utils.reload();
			   }
		}, dataType:"json"};

		var params = {action:'recordGroup'};
		MyForm.prepare(formId, "prefsAccount&"+$.param(params), options, true);

	}

};

window.Prefs = {

	rotateArrow: function(el){
		var $elem = $(el).find("span");
		if ($elem.hasClass("rotated-270"))
			$elem.removeClass("rotated-270").addClass("rotated-180")
		else
			$elem.removeClass("rotated-180").addClass("rotated-270")
	},

	initThirdSpace: function(){
		$('#prefThirdspace_displayCustomWelcom').change(function(){
			$('#thirdSpaceCustomText').toggleClass("hidden");
			if (!$('#thirdSpaceCustomText').hasClass('hidden')){
				MyFacture.customForm('#thirdSpaceCustomText');
			}
		});
	},

	initAbo : function(){
		MyTabs.initHorizontal('subscriptionTabs');
	},

	init: function(){

		// $('#prefsMenu').height($('#contentDiv').height()+80);
		if($("#prefsForm").length > 0){
			var target = $("#prefsForm").attr('action');
			var options = {
				beforeSubmit: function() {
					MyFacture.startWait();
				},
				success:function(data){
					Prefs.recordCallBack(data);
				},
				dataType:"json"
			};
			MyForm.prepare("prefsForm", target, options);
			$("#prefsForm").removeAttr('action');
			$("#prefsForm input[type='submit']").removeAttr('disabled');

			$("select.multipleSelect").multipleSelect({
				countSelected : false,
				placeholder: Loc.g("Choisissez des langues"),
				width: 500,
				selectAll: false,
				position: 'bottom',
				filter: true,
				selectAllText: Loc.g('Tout Sélectionner'),
				allSelected: Loc.g('Tous sélectionnés'),
			});

            MyFacture.customForm();

            Prefs.changeTeamPositions();
            Prefs.setDefaultPosition();
		}
    },

    setDefaultPosition: function(){
        var defaultPosition = $("#prefAccount_defaultposition").val()
        $('#prefAccount_teamposition').find(`option[value="${defaultPosition}"`).prop('selected', true);
    },

    changeTeamPositions: function() {
        var teamSelected = $("#prefAccount_team").val()
        $("#prefAccount_teamposition option").remove();
        var prefAccountTeamPosition = $('#prefAccount_teamposition');
        var allteamspositions = $("#prefAccount_allteamspositions").val();
        if (allteamspositions != undefined){
            var options = JSON.parse($("#prefAccount_allteamspositions").val())[teamSelected];

            if (options && options.dependencies && Object.keys(options.dependencies).length > 0){
                Object.keys(options.dependencies).forEach((index) => {
                    var optionValue = options.dependencies[index].value
                    var optionText = options.dependencies[index].label
                    prefAccountTeamPosition.append(`<option value="${optionValue}">${optionText}</option>`);
                })
            }
        }
    },

	initEmailCustom: function(id) {
		var param = {
			id : id
		};
		MyFacture.post('emailFrame&custom', param, function(data){
			$('#contentCustom').show();
			$('#subjectEmailCustom').html(data.subject);
			$('#iframeContentEmailCustom').contents().find("body").html(data.message);
			$('#btnDeleteCustom').off().on('click', function() {
				Email.deleteCustomTemplate(id);
			});
			$('#btnDuplicateCustom').off().on('click', function() {
				Email.copyCustomTemplate(id);
			});
			$('#btnEditCustom').off().on('click', function() {
				Email.editCustomTemplate(id);
			});
		}, "json");
	},

	initPlugins: function() {

		$('.availablePlugins .addPlugin').live('click',function(){
			$(this).closest('.availablePlugin').find('.checkPlugin').val('Y');
			$('form').submit();
		});

		$('.enabledPlugins .disablePlugin').live('click',function(){
			$(this).closest('.enabledPlugin').find('.checkPlugin').val('N');
			$('form').submit();
		});

	},

	record: function(){

		// patch uploadEngine pour IE 1/2
		if (typeof($(".fileUpload")) != "undefined"){
			$("#prefsCustom_removeCustomFile").find("span").removeClass('ui-button-text');
			var tmpHtml = $(".fileUpload").parent().html();
			var tmpParent = $(".fileUpload").parent();
			$(".fileUpload").parent().html('');
		}

		$('#prefsForm').submit();

		// patch uploadEngine pour IE 2/2
		if (typeof(tmpHtml) != "undefined" && typeof(tmpParent) != "undefined"){
			tmpParent.html(tmpHtml);
			MyFacture.customForm();
		}
	},

	showScaledDetails : function(select){
		if('scaled' == select.find('option:selected').attr('syscode')){
			$('#payDateScaled:hidden').fadeIn();
		}else{
			$('#payDateScaled:visible').fadeOut();
		}

		if('xdays' == select.find('option:selected').attr('syscode') || 'scaled' == select.find('option:selected').attr('syscode')){
			$('#nbdaydefault').show();
		}else{
			$('#nbdaydefault').hide();
		}
	},

	recordCallBack: function(data){
		var formIsOk = MyForm.processJson(data, "prefsForm");
		MyFacture.stopWait();
		if(formIsOk){
			if(data.redirect) {
				Utils.relocate(data.redirect);
			} else {
				Utils.reload();
			}
		}
	},

	initCursor: function(){
		var position = $("#navigationSlide li.active").position();
		$('#navigationSlide #cursor').stop().animate({
			left:position.left
			},0);
		$('#navigationSlide #cursor').fadeIn();
	},

	moveCursor: function(element){
		var position = $(element).position();
		$('#navigationSlide #cursor').stop().animate({
			left:position.left
			},200);
	},


	insertTag: function(textareaId,value, lang){
		if(lang === undefined || lang === ''){
			lang = 'en';
		}
		$("#"+textareaId).redactor('insertHtml', '<img src="/ressources/logged/img/tags/'+lang+'/'+value+'.png" />');
		$("#"+textareaId).redactor('sync');
	},

	removeTag: function(textareaId, element){
		$(this).remove();
		var editors = $("#"+textareaId).cleditor()[0];

		if($("#"+textareaId).attr('preview') !== undefined){
			setTimeout(function(){
				Prefs.updatePreview(textareaId+'Preview',editors);
			},200)	;
		}
	},

	slideMailModel: function(numSlide){
		$('.listModelMail .slide').animate({
			left:-920*(numSlide-1)
			},500);

		$('.linkSlideModelMail').removeClass('btn-primary');
		$('.linkSlideModelMail').addClass('btn-default');
		$('#linkSlideModelMail_'+numSlide).removeClass('btn-default');
		$('#linkSlideModelMail_'+numSlide).addClass('btn-primary');
	},

	updatePreview: function(idPreview, editor){

		var txt = editor.$main.find('iframe').contents().find('body').html();
		var reg1 = new RegExp('<img src="(ftp|http|https)://'+window.location.hostname+'/', 'g');
		var reg4  = new RegExp('<img src="/ressources/logged/img/',"g");

		var reg3  = new RegExp('img/tags/[a-z]{2}/',"g");
		var reg5  = new RegExp('.png"[^>]*>' ,"g");

		txt = txt.replace(reg1,'%');
		txt = txt.replace(reg4,'%');

		txt= txt.replace(reg3,'');
		txt= txt.replace(reg5,'%');

		txt= Prefs.replaceTags(txt);
		$('#'+idPreview).html(txt);
		editor.$main.find('iframe').contents().find('body').find('img').click(function(){
			$(this).remove();
		});
	},

	replaceTags: function(txt){
		var tags = Persistent.get("metaCustomList", true,true);

		var find = new Array();
		var rep = new Array();
		var reg1 = new RegExp('&lt;','g');
		var reg2 = new RegExp('&gt;','g');


		for (var t in tags){

			var tag = tags[t].toString();
			tag = tag.replace(reg1, '<');
			tag = tag.replace(reg2, '>');
			tags[t]= tag;
			find.push('%'+t+'%');
			rep.push(tags[t]);
		}

		for(var i=0; i<find.length;i++){
			var reg = new RegExp(find[i],'g');
			txt=txt.replace(reg,rep[i]);

		}
		return txt;
	},

	updateStaffPicture : function(data){
//		data = data[0];
		if(data.success){
			window.avatarHeader	= $('.corpinfos').find('img');
			window.avatar		= $('#staffPicture');

			window.src = data.file + '&' + Utils.generateRandom();

			avatarHeader.fadeOut().attr('src', src).fadeIn();
			avatar.fadeOut().attr('src', src).fadeIn();

			$('#deleteStaffPicture').fadeIn();
			MyFacture.customForm($('.deleteStaffPicture'));
		}

	},

	removeStaffPicture : function() {
		var param = '';
		MyFacture.post('prefsCoords&action=removeStaffPicture', param, function(data){
			$('#staffPicture').attr('src', '/ressources/logged/img/common/people.jpg');
			$('#staffPicture').fadeIn();
			$('#deleteStaffPicture').fadeOut();
		}, "json");
	},

	updateStaffSign : function(data){
		if(data.success){
			$('#staffSign').fadeOut();
			$('#staffSign').attr('src', data.file);
			$('#staffSign').fadeIn();
			$('#deleteStaffSign').fadeIn();
			MyFacture.customForm($('.deleteStaffSign'));
		}

	},

	removeStaffSign: function() {
		var param = '';
		MyFacture.post('prefsCoords&action=removeStaffSign', param, function(data){
			$('#staffSign').attr('src', '/ressources/logged/img/common/signature.png');
			$('#staffSign').fadeIn();
			$('#deleteStaffSign').fadeOut();
		}, "json");
	},

	updateLogoPreview: function(data){
		if(data.success){
			$('#logoImg img').fadeOut('fast').attr('src', data.file+'&'+(new Date().getUTCMilliseconds())).fadeIn();
			$('#deleteLogo').fadeIn();
		}
	},

	removeCorpLogo : function() {
		var param = '';
		MyFacture.post('companyPreferences&action=logoRemove', param, function(data){
			$('#deleteLogo').fadeOut();
			$('#logoImg img').attr('src', '/ressources/logged/img/common/logo.png');
		}, "json");
	},

	formatNum: function(field){
		var numformat = Prefs.getNumFormat();
		var toFloat = NumberFormat.formatToFloat(field.val(), numformat);
		field.val(NumberFormat.formatToDisplay(toFloat, numformat));
	},

	changeNumFormatSeparators : function(){

		var decimals = $('select[name=prefGeneral_separators] option:selected').attr('decimals');
		var thousands = $('select[name=prefGeneral_separators] option:selected').attr('thousands');

		$('input[name=prefGeneral_numberdecimals]').val(''+decimals);
		$('input[name=prefGeneral_numberthousands]').val(''+thousands);
	},

	getNumFormat: function(){
		return Persistent.get("numformat", true);
	},

	initBankAccount : function(){
		$('.hasIban').change(function(){
			$(this).closest('.bankAccount').find('.data-group').hide();
			$(this).closest('.bankAccount').find('.hasiban-'+$(this).val()).show();
		});
	},

	editItemsList: function(listName){
		RankedList.editItemsList(listName, Prefs.getNumFormat(), '', 'Prefs.recordItemsListCallback');
	},

	recordItemsListCallback: function(data){
		var formIsOk = MyForm.processJson(data, "itemsListForm");
		if(formIsOk){
			var itemsListSelector	= data.listname		? data.listname+"itemslist"	: "";
			var itemsListContent	= data.listcontent	? data.listcontent			: "";
			if(0<itemsListSelector.length && 0<itemsListContent.length){
				var id		= "";
				var divId	= "";
				switch(data.listname){
					case "packagings":
						id		= "prefDoc_defaultPackaging";
						divId	= "defaultPackagingDiv";
						break;
					case "shippings":
						id		= "prefDoc_defaultShipping";
						divId	= "defaultShippingDiv";
						break;
				}
				var oldSelected = $("#"+id).val();
				$("#"+divId).html(itemsListContent);

				$("#"+id).val(oldSelected);
				MyFacture.customForm("#"+divId);

				if ($(".prefsShippings").length > 0){
					Utils.reload();
				}
			}
			MyWindow.close();
		}
	},

	editTaxes: function(){
		RankedList.editValuesList('taxes', Prefs.getNumFormat(), 'dropdown', '', 'Prefs.recordTaxesCallback');
	},

	recordTaxesCallback: function(data){

		var formIsOk = MyForm.processJson(data, "valuesListForm");

		if(formIsOk){

			var valuesListContent	= data.listcontent	? data.listcontent				: "";

			var id		= "";
			var divId	= "";

			id		= "prefsNewVat_newTaxId";
			divId	= "newTaxId";

			var oldSelected = $("#"+id).val();
			$("#"+divId).html(Text.replace(valuesListContent, 'prefDoc_defaultTaxid', 'prefsNewVat_newTaxId'));
			$("#"+id).val(oldSelected);
			MyFacture.customForm("#"+divId);

			id		= "prefsNewVat_currentTaxId";
			divId	= "currentTaxId";

			var oldSelected = $("#"+id).val();
			$("#"+divId).html(Text.replace(valuesListContent, 'prefDoc_defaultTaxid', 'prefsNewVat_currentTaxId'));
			$("#"+id).val(oldSelected);
			MyFacture.customForm("#"+divId);

			$('.padtb5').hide();
			MyWindow.close();
		}

	},

	editValuesList: function(listName){
		RankedList.editValuesList(listName, Prefs.getNumFormat(), 'dropdown', '', 'Prefs.recordValuesListCallback');
	},

	recordValuesListCallback: function(data){
		var formIsOk = MyForm.processJson(data, "valuesListForm");
		if(formIsOk){

			var valuesListSelector	= data.listname		? data.listname+"valueslist"	: "";
			var valuesListContent	= data.listcontent	? data.listcontent				: "";
			if(0<valuesListSelector.length && 0<valuesListContent.length){
				if("paymediums" == data.listname){
					var checked = new Array();

					$(".paymediums").each(function(){
						if($(this).prop("checked")){
							checked.push($(this).attr("id"));
						}
					});

					$("#paymediumDiv").html(Text.replace(valuesListContent, "%idToSet%", "paymedium"));

					for(var c=0; c<checked.length; c++){
						$("#"+checked[c]).prop("checked", true);
					}

					MyFacture.customForm("#paymediumDiv");
				} else {
					var id		= "";
					var divId	= "";
					switch(data.listname){
						case "labels":
							id		= "aevent_labelid";
							divId	= "defaultLabelsListDiv";
							break;
						case "projectentrylabels":
							id		= "prefsProject_labelid";
							divId	= "defaultProjectLabel";
							break;
						case "paydates":
							id		= "prefDoc_payDates";
							divId	= "paydateDiv";
							break;
						case "paycheckorders":
							id		= "prefDoc_payCheckOrders";
							divId	= "paymedium_checkOrdersListDiv";
							break;
						case "docspeakers":
							id		= "prefDoc_defaultSpeaker";
							divId	= "defaultDocSpeakersListDiv";
							break;
						case "units":
							id		= "prefDoc_defaultUnit";
							divId	= "defaultUnitDiv";
							break;
						case "taxes":
							id		= "prefDoc_defaultTax2id";
							divId	= "defaultTax2Div";
							var oldSelected = $("#"+id).val();
							$("#"+divId).html(Text.replace(valuesListContent, 'prefDoc_defaultTaxid', 'prefDoc_defaultTax2id'));
							$("#"+id).val(oldSelected);
							MyFacture.customForm("#"+divId);

							id		= "prefDoc_defaultTaxid";
							divId	= "defaultTaxDiv";
							break;
						case "phonecalltypes":
							id = "prefs_defaultValue";
							divId = "defaultPhoneCallLabel";
							break;
					}

					var oldSelected = $("#"+id).val();
					$("#"+divId).html(valuesListContent);
					$("#"+id).val(oldSelected);
					MyFacture.customForm("#"+divId);
				}
			}
			MyWindow.close();
		}
	},

	removeCustomBackgroundPreview : function(id) {
		var param = {
			layoutid:id
		};
		MyFacture.post('prefsDocs&action=layoutRemoveCustom', param, function(data){
			$('#pdfBackgroundPreview img').fadeOut();
			$('#pdfBackgroundPreview img').attr('src','');
			$('#pdfBackgroundPreview img').fadeIn();
			$('#prefsCustom_removeCustomFile').fadeOut();

			var layoutDatas = Persistent.get('layoutDatas',true);
			Persistent.set('layoutDatas',{
				'urlsystem':layoutDatas.urlsystem,
				'urlcustom':''
			});
			$('#prefsCustom_bgFile option[value=custom]').attr('selected','selected').trigger('change');
		}, "json");
	},

	updateCustomBackgroundPreview : function (data){

		if(data.success){
			var layoutDatas = Persistent.get('layoutDatas',true);
			$('#pdfBackgroundPreview').fadeOut();
			$('#prefsCustom_removeCustomFile').fadeIn();
			Persistent.set('layoutDatas',{
				'urlsystem':layoutDatas.urlsystem,
				'urlcustom':data.file
				});
			$('#prefsCustom_bgFile option[value=custom]').attr('selected','selected').trigger('change');
//			$("#prefsCustom_bgFile").selectmenu("value", 'custom');
			$("#prefsCustom_bgFile").val('custom');

			MyFacture.customForm($('.prefsCustom_removeCustomFile'));
		} else {
		    var msg = (data.error !== undefined && data.error != '') ? data.error : window.i18n.gettext("Une erreur est survenue!");
		    Push.error(msg);
		}
	},

	confirmRecord: function(){
		MyWindow.alert(Loc.g('Vos informations ont bien été mises à jour'),{
			type:'confirm',
			title:'Confirmation'
		});
	},

	confirmReinit : function(){
		var options = {
			title	: Loc.g("Reinitialisation du compte"),
			width	: 600,
			buttons	: [
                {
                    text : Loc.g("Annuler"),
                    click : function() {
                        $(this).dialog("close");
                    }
                },
                {
                    text : Loc.g("Valider"),
                    click : function() {
                        let $parent = $(this);
                        MyWindow.alert(
                            Loc.g('Cette action est irréversible. Êtes-vous sûr de vouloir réinitialiser les données selectionnées ?'),
                            {
                                width : 400,
                                resizable : false,
                                noclose : true,
                                title : Loc.g("Confirmation"),
                                buttons : [
                                    {
                                        text : Loc.g("Non"),
                                        'class'	: ' btn btn-default',
                                        click : function(){
                                            $(this).dialog("close");
                                        }
                                    },
                                    {
                                        text : Loc.g("Oui"),
                                        click : function(){
                                            $('#reinitAccountForm').submit();
                                            $(this).dialog("close");
                                            $parent.dialog("close");
                                        }
                                    }
                                ]
                            }
                        );
					}
				},
			],
			callback : function(){
				Prefs.prepareConfirmReinit('reinitAccount', 'reinitAccountForm');
			}

		};

		var params = {
			action:"reinitForm"
		};

        MyWindow.load("dataPreferences", params, options );

	},

	prepareConfirmReinit : function(action, formid){

		MyFacture.customForm();

		$('.data-list input[type=checkbox]').click(function(){
			Prefs.checkIfSelectedAllBloc($(this).parents('.data-list'));
		});

		var options = {
			success: function (data) {
				var formIsOk = MyForm.processJson(data, "groupForm");
				if (formIsOk) {

					var opt = {
						title: Loc.g('Réinitialisation des données'),
						type: 'confirm',
						buttons: [
							{
								text: Loc.g("Ok"),
								click: function () {
									$(this).dialog("close");
								}
							}
						],
					};
					MyWindow.alert(Loc.g("La réinitialisation des données a été planifiée. Elle sera effective sous peu."), opt);

				} else {
					fields = data.form.fields;
					$.each(fields, function (i, field) {
						if($('#'+field.fieldId+"Alert").length > 0){
							$('#'+field.fieldId+"Alert").slideDown().html(field.msg);
						}
					});
				}
			},
			dataType: "json"
		};

        MyForm.prepare(formid, "dataPreferences&" + $.param({action: action}), options, true);


	},

	reinitIt : function(reinit, staffIds){
		var datas = {
			'action'	: 'reinitAccount',
			'reinit'	: reinit,
			'staffIds'	: staffIds
		};

        MyFacture.post("dataPreferences", datas, function(data) {
			Prefs.reinitItCallback(data)
		}, "json");

		return true;
	},

	supprIt : function(passwd){
		var datas = {
			'action' : 'deleteAccount',
			'passwd' : passwd
		};

		MyFacture.post(
			"dataPreferences", datas, function(data) {
				Prefs.supprItCallback(data)
			}, "json"
			);

		return true;
	},

	reinitItCallback: function(data){
		var formIsOk = MyForm.processJson(data, "");
			MyWindow.close();
		if(formIsOk){
			MyWindow.alert(Loc.g('Vos informations ont bien été réinitialisées'), {
				type:'confirm'
			});
		}else{
			MyWindow.alert(Loc.g('Une erreur est survenue !'), {
				type:'error'
			});
		}
	},

	supprItCallback: function(data) {
		var formIsOk = MyForm.processJson(data, "");
			MyWindow.close();
		if(formIsOk){
			MyWindow.alert(Loc.g('Votre demande de suppression de compte a bien été prise en compte.'), {
				type:'confirm',
				close: function(){
					Utils.relocate('/');
				}
			});
		}else{
			MyWindow.alert(data.form.msg, {
				type:'error'
			});
		}
	},

	changeNumFormat: function(){

		var selected		= $('#prefGeneral_numberformat option:selected');

		$("#prefGeneral_numberdecimals").val(selected.attr("decimals"));
		$("#prefGeneral_numberthousands").val(selected.attr("thousands"));
//		$("#prefGeneral_currencyposition").selectmenu('value', selected.attr("currencypos"));
		$("#prefGeneral_currencyposition").val(selected.attr("currencypos"));
	},

	initLayout : function(){
		$('.colorPicker').colpick({
			layout		: 'hex',
			submit		: 0,
			colorScheme	: 'light',
			onChange	: function(hsb, hex, rgb, el, bySetColor) {

				$(el).parent().find('.append').css('background-color','#'+hex);

				var colorid = $(el).closest('.form-group').attr('id');

				Prefs.updateLayout(colorid);
				// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
				$(el).val(hex);
			}
		}).unbind('keyup').keyup(function(){
			$(this).colpickSetColor(this.value);
		}).trigger('keyup');

		MyTabs.initVertical('prefsContent');
	},

	updateLayout: function(type){
		var layoutDatas = Persistent.get('layoutDatas',true);

		switch(type) {

			case 'colorText' :
				$('.colorText').css({
					'color':'#'+$('#prefsCustom_colorText').val()
				});
			break;

			case 'colorNotes':
				$('#preview_notes').css({
				'color':'#'+$('#prefsCustom_colorNotes').val(),
				'border-color':'#'+$('#prefsCustom_colorNotes').val()
				});
			break;

			case 'colorHeaderRow':
				$('.colorLabel').css({
				'color':'#'+$('#prefsCustom_colorHeaderRow').val()
				});
			break;

			case 'hideTopPart':
				if($('#prefsCustom_hideTopPart').is(':checked')){
					$('#preview_header_show #preview_sender.header-hide').hide();
                    $('#preview_objet').css('padding-top', '350px');
				} else {
					$('#preview_header_show #preview_sender.header-hide').show();
                    $('#preview_objet').css('padding-top', '160px');
				}
				break;

			case 'hideBottomSeparator':
				if($('#prefsCustom_hideBottomSeparator').is(':checked')){
					$('#preview_footer').css({
						'border-top': 'none'
					});
				} else {
					$('#preview_footer').css({
						'border-top': '1px solid #CCC',
						'border-color': 'rgb(0, 0, 0)'
					});
				}
				break;

			case 'hideFill':
				if($('#prefsCustom_hideFill').is(':checked')){
					$('.hideFill').addClass('HideFillTrue');
				} else {
					$('.hideFill').removeClass('HideFillTrue');
				}
				break;

			case 'colorFill':
				$('.colorFill').css({
					'border-color':'#'+$('#prefsCustom_colorFill').val()
				});
			break;

			case 'colorHeaderFooter':
				$('.BTPart').css({
					'border-color':'#'+$('#prefsCustom_colorHeaderFooter').val(),
					'color':'#'+$('#prefsCustom_colorHeaderFooter').val()
				});
			break;

			case 'font':
				$('#previewLayout').css({
					'font-family':$('#prefsCustom_font').val()
				});
			break;

			case 'bgFile' :
				Prefs.updateBg($('#prefsCustom_bgFile').val());
				break;

			case 'bgMode' :
				Prefs.updateBgMode($('#prefsCustom_bgMode').val());
				break;

			case 'headerMode' :
				if($('#prefsCustom_headerMode').val() == 'all' || $('#prefsCustom_headerMode').val() == 'first' || $('#prefsCustom_headerMode').val() == 'even'){
					$('#preview_topart').show();
				} else {
					$('#preview_topart').hide();
				}
				break;

			case 'footerMode' :
				if($('#prefsCustom_footerMode').val() == 'all' || $('#prefsCustom_footerMode').val() == 'first' || $('#prefsCustom_footerMode').val() == 'even'){
					$('#preview_footer').show();
				} else {
					$('#preview_footer').hide();
				}
				break;

			case 'logoMode' :
				if($('#prefsCustom_logoMode').val() == 'all' || $('#prefsCustom_logoMode').val() == 'first' || $('#prefsCustom_logoMode').val() == 'even'){
					$('#preview_sender img').show();
				} else {
					$('#preview_sender img').hide();
				}
				break;

			case 'hideDepositRecap' :
				if($('#prefsCustom_hideDepositRecap').is(':checked')){
					$('#preview_depositRecap').hide();
				} else {
					$('#preview_depositRecap').show();
				}
				break;

		}

		if(type === 'all'){

			Prefs.updateLayout('colorText');
			Prefs.updateLayout('colorNotes');
			Prefs.updateLayout('colorHeaderRow');
			Prefs.updateLayout('hideTopPart');
			Prefs.updateLayout('hideBottomSeparator');
			Prefs.updateLayout('hideFill');
			Prefs.updateLayout('colorFill');
			Prefs.updateLayout('colorHeaderFooter');
			Prefs.updateLayout('font');
			Prefs.updateLayout('bgFile');
			Prefs.updateLayout('bgMode');
			Prefs.updateLayout('headerMode');
			Prefs.updateLayout('footerMode');
			Prefs.updateLayout('logoMode');

		}
	},

	alignDocNumber : function(){
		$('#warningAlignDocNumber').toggle('medium');
	},

	updateBg: function(name) {

		var bg = "";
		var layoutDatas = Persistent.get('layoutDatas',true);

		if('custom'!=name) {
			bg = layoutDatas.urlsystem+name+'.jpg';
			$('#previewLayout').css({
				'background-image':'url('+bg+')'
				});
		} else {
			bg = layoutDatas.urlcustom;
			bg = bg.replace('&amp;','&');
			$('#previewLayout').css({
				'background-image':'url('+bg+')'
				});
		}

	},

	updateBgMode: function(mode) {
		if(mode=='all' || mode=='first' || mode=='even'){
			$('#previewLayout').css({
				'background-position':'0px 0px'
			});
		} else {
			$('#previewLayout').css({
				'background-position':'-10000px -20000px'
			});
		}
	},

	deleteLayout: function(id){
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Attention!"),
			type		: "warning",
			buttons		: [
				{
					text : Loc.g("Non"),
					click : function(){
						$(this).dialog("close");
						return false;
					}
				},
				{
					text : Loc.g("Oui"),
					click : function(){
						Prefs.do_deleteLayout(id);
						$(this).dialog("close");
					}
				},

			]
	};
	MyWindow.alert(Loc.g("Vous êtes sur le point de supprimer ce modèle, voulez vous contiuer ?"), options);

	},

	do_deleteLayout: function(id){
		MyFacture.post('prefsDocs', {
			id:id,
			action:'layoutDelete'
		}, function(data){
			Prefs.deleteLayoutCallBack(data)
			}, 'JSON');
	},

	deleteLayoutCallBack : function(data) {
		Utils.reload();
	},

	toggleLayouttab : function(tabIndex, me){
		$('.paramLayoutSubContainer').hide();
		$('#'+tabIndex).fadeIn();
		$('.current').removeClass('current');
		me.addClass('current');
		MyFacture.customForm();
	},

	switchVatPreview : function(me){
		var vat = me.val();
		switch (vat){
			case "ttcdoc":
				$('#previewLayout').removeClass().addClass('showTTC');
				break;
			case "htdoc":
				$('#previewLayout').removeClass().addClass('showHT');
				break;
		}
	},

	switchLayoutTrad: function(lang){

		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Attention!"),
			type		: "warning",
			buttons		: [
			{
				text : Loc.g("Non"),
				click : function(){
					$(this).dialog("close");
					return false;
				}
			},
			{
				text : Loc.g("Oui"),
				click : function(){
					Prefs.do_switchLaoutTrad(lang);
					$(this).dialog("close");
				}
			}
		]
	};
	MyWindow.alert(Loc.g("Les modifications effectuées sur les textes seront perdues. Continuer?"), options);

	},

	do_switchLaoutTrad: function(lang){
		var langForLoad = defaultLayoutTxts[lang];
		for (var i in langForLoad){
			$('#previewLayout input[name="prefsCustom_txts['+i+']"]').val(langForLoad[i]).attr('placeholder', langForLoad[i]);
		}
	},

	editTemplate : function(template){
		var	options = {
				title	: Loc.g("Modification du modèle d'email"),
				buttons	: [
                    {
                        text : Loc.g("Annuler"),
                        click : function() {$(this).dialog("close");}
                    },
                    {
						text : Loc.g("Enregistrer"),
						click : function() {$('#templateForm').submit();}
					},
				],
				width : 850,
				callback : function(data){Prefs.prepareEditTemplate()}
			};

        MyWindow.load("emailPreferences", { action:"emailsForm", template : template}, options );
	},

	prepareEditTemplate : function(){
		var formId = "templateForm";
		var options = {success:function(data){Prefs.recordTemplateCallback(data);}, dataType:"json"};
        MyForm.prepare(formId, "emailPreferences&action=emailRecord", options, true);
		MyFacture.customForm();
	},

	recordTemplateCallback : function(data){

		var formIsOk = MyForm.processJson(data, "templateForm");

		if(formIsOk){

			$('#content_'+data.emailTpl.name).find('.subject').html(data.emailTpl.subject);
			var iframe  =	$('#content_'+data.emailTpl.name).find('.message iframe');
			var message =	$('#content_'+data.emailTpl.name).find('.message');
			if (iframe.length > 0){
				iframe.attr('src', iframe.attr('src'));
			} else {
				message.html(data.emailTpl.content);
			}

			MyWindow.close();
			Prefs.redimTabs();
		}
	},

	initTabs : function(){
		$('.tab-container').find('.tab-title a').on('click',function(){
			var id = $(this).attr('id');
			$(this).parent().find('a').removeClass('current');
			$(this).addClass('current');
			var tabContent = $(this).closest('.tab-container').find('.tab-content');
			tabContent.find('#content_'+id).show();
			tabContent.find('>div:not(#content_'+id+')').hide();
		});

		var maxHeight = 0;
		$('.tab-content > div').each(function(){
			if($(this).height() > maxHeight){
				maxHeight = $(this).height();
			}
		});
		$('.tab-content').height(maxHeight+22);
	},

	redimTabs : function(){
		var maxHeight = 0;
		$('.tab-content > div').each(function(){
			if($(this).height() > maxHeight){
				maxHeight = $(this).height();
			}
		});

		$('.tab-content').height(maxHeight+22);
	},

	setDefaultLayout : function(layoutid){
		MyFacture.post("prefsDocs", {action:"layoutsDefault", layoutid : layoutid}, function(data){}, "json");
	},

	editRateCateg : function(rcid){
		var rateCategID = rcid != undefined ? rcid : '';
		var title = rcid != undefined ? Loc.g('Modification de la catégorie tarifaire') : Loc.g('Ajout d‘une catégorie tarifaire');

		var options = {
			title	: title,
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}},
                {text : Loc.g("Enregistrer"), click : function(){$("#rateCategForm").submit();}}
			],
			width:650,
			callback	: function(){Prefs.prepareRateCategForm();}
		};
		MyWindow.load('catalogPreferences', {action:'rateCategoryForm', rcid : rateCategID}, options);
	},

	prepareRateCategForm : function(){
		var formId = "rateCategForm";
		var options = {
			success:function(data){Prefs.recordRateCategCallback(data);},
			dataType:"json"
		};

		$('input[name=rc_priceRule]').change(function(){
			if($(this).val() == 'percent'){
				$('div#pricePercent').fadeIn(200, function(){
					MyFacture.customForm('div#pricePercent');
				});
			}else{
				$('div#pricePercent').fadeOut(200);
			}
		});

        MyForm.prepare(formId, "catalogPreferences&action=rateCategoryRecord", options, true);
		MyFacture.customForm();
	},

	recordRateCategCallback : function(data){
		var formIsOk = MyForm.processJson(data, "rateCategForm");
		if(formIsOk){
            Utils.reload();
        }
	},

	setDefaultRateCateg : function(rcid){
        MyFacture.post("catalogPreferences", {action:"rateCategoryDefault", rcid : rcid}, function(data){
			$(".deleteRateCateg:not(#rateCateg"+rcid+" .deleteRateCateg)").show();
			$("#rateCateg"+rcid+" a.deleteRateCateg").hide();
		}, "json");
	},


	deleteRateCateg : function(rcid){
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'une catégorie tarifaire"),
			type		: 'warning',
			width		: 500,
			buttons		: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text :
					Loc.g("Valider"),
					click : function(){
						Prefs.doDeleteRateCateg(rcid);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Tous les clients et documents liés à cette catégorie seront liés à la catégorie par défaut.")+"<br /><br />"+Loc.g("Supprimer la catégorie tarifaire?"), options);
	},

	doDeleteRateCateg : function(rcid){
        MyFacture.post("catalogPreferences", {action:"rateCategoryDelete", rcid : rcid}, function(data){
			if ((typeof data.success != 'undefined') && (data.success == 'Y')) {
				// Success
				$("#rateCateg"+rcid).slideUp(300, function(){
					$(this).remove();
				});
			}
			if (typeof data.error != 'undefined') {
				// Known error
				Push.error(data.error);
			}
		}, "json");
	},

	addVatMapEntry : function(){
		var $vatEntry = $('.vatMap li.template').clone();
		var time = new Date().getTime();
		var newid = Math.ceil(Math.random() * 100)+time+Math.ceil(Math.random() * 1000);

		$vatEntry.removeClass('template');
		$vatEntry.removeClass('hidden');


		$vatEntry.find('.oldvatSelect').attr('name', 'vatMap['+newid+'][oldvat]').attr('id', 'vatMap_'+newid+'_oldvat');
		$vatEntry.find('.newvatSelect').attr('name', 'vatMap['+newid+'][newvat]').attr('id', 'vatMap_'+newid+'_newvat');

		$vatEntry.insertBefore('.vatMap li.template');
		MyFacture.customForm();
	},

	deleteVatEntry : function(elt){
		$(elt).closest('li:not(li.template)').remove();
	},

	setActionForNewVat : function(action){
		$('#prefsForm input[name=action]').val(action);
		$('#prefsForm').submit();
	},

	applyPaymediumToAllThirds : function() {

		var listPaymedium = new Array();

		$("#paymediumDiv input[type=checkbox]:checked").each(function(index, elem) {
			var paymed = $(elem).attr("name").split("_");
			var paymedId = paymed[1];

			listPaymedium.push(paymedId);

		});

		var msg =  Loc.g("Etes vous sur de vouloir appliquer ces moyens de paiement à tous vos clients ?");
		var options = {
			type		: 'warning',
			title		: Loc.g("Moyens de paiement mis à jour"),
			buttons		: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Appliquer"), click : function(){
					MyFacture.post('prefsDocs&action=applyPaymediumToAllThirds', {'listPaymedium' : listPaymedium}, function(data){
						var msg2 =  Loc.g("Les moyens de paiements ont été mis à jour pour tous vos clients.");
						var options2 = {
							type		: 'confirm',
							title		: Loc.g("Moyens de paiement mis à jour"),
							buttons		: [
								{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");$("#prefsForm").submit();}}
							]
						};
						MyWindow.alert(msg2, options2);
					}, "json");
				}}
			]
		};

		MyWindow.alert(msg, options);

	},

	applyPaymentConditionsToAllThirds : function() {
		var params = {};
		var formData = $('#prefsForm').serializeArray();
		var allowedFields = ['prefDoc_payDateid', 'prefDoc_payDateXDays', 'prefDoc_payDateScaledDetails', 'prefDoc_deposit', 'prefDoc_depositUnit']
		for (var i in formData) {
			if (allowedFields.includes(formData[i]['name'])) {
				params[formData[i]['name']] = formData[i]['value'];
			}
		}

		var msg =  Loc.g("Etes vous sur de vouloir appliquer ces conditions de règlement à toutes vos sociétés ?");
		var options = {
			type		: 'warning',
			title		: Loc.g("Conditions de règlement mise à jour"),
			buttons		: [
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
				{text : Loc.g("Appliquer"), click : function(){
						MyFacture.post('prefsDocs&action=_applyPaymentConditionsToAllThirds', params, function(data){
							var msg2 =  Loc.g("Les conditions de règlement ont été mises à jour pour toutes vos sociétés.");
							var options2 = {
								type		: 'confirm',
								title		: Loc.g("Conditions de règlement mises à jour"),
								buttons		: [
									{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");$("#prefsForm").submit();}}
								]
							};
							MyWindow.alert(msg2, options2);
						}, "json");
					}}
			]
		};

		MyWindow.alert(msg, options);
	},

	toggleWarningContact : function() {
		$("#warningDeleteContact").toggle('medium');
	},

	addTranslationLangForm : function () {

		var options = {
			title	: Loc.g("Langues de traduction"),
			buttons	: [
				{
					text 	: Loc.g("Annuler"),
					'class'	:'btn btn-default',
					click 	: function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"),
					'class'	:'btn btn-primary',
					click 	: function(){
						$("#translationLangForm").submit();
					}
				}
			],
			width		: 600,
			callback	: function(){
				Prefs.prepareTranslationLangForm();
			}
		};

		MyWindow.load("prefsAccount", {action:"translationLangForm"}, options);
	},

	prepareTranslationLangForm : function () {

		var formId = "translationLangForm";
		var options = {
			success:function(data){
				$("#error-msg").hide();
				$("#error-msg").html("");
				var formIsOk = MyForm.processJson(data, "translationLangForm");
				if(formIsOk){
					Utils.reload();
				}else {

					if(data.form.status == "error") {
						$("#error-msg").show();
						$("#error-msg").html(data.form.msg);
					}
				}
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "prefsAccount&action=translationLangFormRecord", options, true);

		Qtip.init();

	},

	displayFlagSelect : function(row) {
		var flagList = $("#flagsList").html();
		$("#old_content_"+row).html($("#preview_flag_"+row).html());
		$("#preview_flag_"+row).html(flagList);
	},

	selectFlag : function(flag, elem) {
		var divContent = elem.parent('div').parent('div');
		divContent.html("<img src='/ressources/public/img/flags/"+flag+".png' height='16' onClick='Prefs.displayFlagSelect("+divContent.attr("row")+")' />");
		$("#tlang_flag_"+divContent.attr("row")).val(flag);
	},

	cancelFlagSelect : function(elem) {
		var indice = elem.parent("div").attr("row");
		elem.parent("div").html($("#old_content_"+indice).html());
		$("#old_content_"+indice).html("");
	},

	addTranslationLangRow : function() {

		$("tr.placeholder").hide();

		var indice = parseInt($("#nextIndice").val());
		var html = "";

		$("#langsList .placeholder").hide();

		html += "<tr>";
		html += "	<input type='hidden' name='tlang_indice[]' value='"+indice+"' />";
		html += "	<td>";
		html += "		<input type='text' id='tlang_lang_"+indice+"' name='tlang_lang_"+indice+"' value='' />";
		html += "	</td>";
		html += "	<td align='center' style='padding:0;'>";
		html += "		<div class='selectFlag' id='preview_flag_"+indice+"' row='"+indice+"' >";
		html += "			<a href='javascript:;' class='btn btn-primary btn-small' onClick='Prefs.displayFlagSelect("+indice+");' >"+Loc.g('Choisir un drapeau')+"</a>";
//		html += "			<img src='/ressources/public/img/flags/blank.png' height='16' onClick='Prefs.displayFlagSelect("+indice+");' /> ";
		html += "		</div>";
		html += "		<input type='hidden' id='tlang_flag_"+indice+"' name='tlang_flag_"+indice+"' value='' />";
		html += "		<span class='hidden' id='old_content_"+indice+"'></span>";
		html += "	</td>";
		html += "	<td align='center'>";
		html += "		<a id='askDelete_"+indice+"' href='javascript:;' onClick='Prefs.deleteTranslateLangRow($(this));'>";
		html += "			<i class='fa fa-trash-o fa-black'><xsl:comment/></i>";
		html += "		</a>";
		html += "	</td>";
		html += "</tr>";

		$("#langsList tbody").append(html);
		$("#nextIndice").val(indice+1);
	},

	deleteTranslateLangRow : function (elem) {

		elem.parent('td').parent('tr').remove();

		if($("#langsList tbody tr").not(".placeholder").length === 0) {
			$("#langsList tbody tr.placeholder").show();
		}

	},

	deleteTranslateLang : function (id, elem) {

		var msg =  Loc.g("Etes vous sur de vouloir supprimer cette langue ?<br/>Toutes les traductions saisis pour cette langue seront supprimées.");
		var options = {
			type		: 'warning',
			width		: 350,
			title		: Loc.g("Supprimer une langue de traduction"),
			buttons		: [
                {
					text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Valider"),
					'class' : 'btn btn-primary',
					click : function(){
						MyFacture.post('prefsAccount&action=deleteTranslateLang', {id: id}, function(data){
							elem.parent("span").parent("td").parent("tr").remove();
							if($("#langsList tbody tr").not(".placeholder").length === 0) {
								$("#langsList tbody tr.placeholder").show();
							}
						}, "json");
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(msg, options);

	},

	switchTranslation : function(langid, prefix = 'translation_') {
		$("textarea.translatable.redactor[dir='ltr']").redactor("destroy");
		$("textarea.translatable.redactor").removeAttr("dir");
		$(".translatable").hide();

		$(".lang_"+langid).show();

		if($('.tab-h-menu').length > 0){
			$('.tab-h-menu li.current').removeClass('current');
            $('#'+prefix+langid).parents('li').addClass('current');
		}

		MyFacture.customForm($("textarea.redactor.translatable.lang_"+langid).parent());
	},

	resetCustomTagEngine : function(langid, container, lang) {
		var id = langid === 0 ? 'prefDisplay_footer' : 'prefDisplay_footer_'+langid;
		$('#'+container+' label.form-label a').attr("onclick", "Prefs.insertTag('"+id+"',$(this).closest('.form-group').find('select option:selected').val(), '"+lang+"')");
	},

	recordDefaultLayout : function(doctypeid, doctype){

		$('#loader_'+doctypeid).css('display', 'block');
		var layoutid = $('#defaultLayout_'+doctypeid).val();

		var options = {action: "recordDefaultLayout", doctypeid: doctypeid, doctype:doctype, layoutid: layoutid};
		MyFacture.post("prefsDocs", options, function (data) {
			$('#loader_'+doctypeid).css('display', 'none');
		}, "json");
	},

	checkAllReinit : function(checkbox){
		var ul = checkbox.parent().parent().next('ul');
		if(ul.length > 0){
			if(checkbox.is(':checked')){
				ul.find('input[type=checkbox]').attr('checked', 'checked')
			} else {
				ul.find('input[type=checkbox]').removeAttr('checked');
			}
		}
	},

	checkIfSelectedAllBloc : function(container){
		var checkAll = container.prev('legend').find('input[type=checkbox]');

		var total = container.find('input[type=checkbox]').length;
		var checked = container.find('input[type=checkbox]:checked').length;

		if(total !== checked && checkAll.prop('checked')){
			checkAll.prop('checked', false);
		} else if(total == checked && !checkAll.prop('checked')){
			checkAll.prop('checked', true);
		}
	}
};

window.PermissionProfile = {

	initListTable : function(){
		$('.tableSort').tablesorter({textExtraction:function(node){return $(node).find('input').val();}});
	},

	deleteProfile : function (permprofileid){

		var options = {
			'type' : 'warning',
			buttons	: [
				{
					text : Loc.g("Non"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					click : function(){
						MyFacture.post('prefsAccount', {'action':'permissionProfileFormDelete', permprofileid:permprofileid}, function(){
							Utils.reload();
						});
					}
				}
			],
		};

		MyWindow.alert(Loc.g('Êtes vous sur de vouloir supprimer ce profil ?'), options);

	},

	edit : function(permprofileid, duplicate){

		var options = {
			title	: Loc.g('Profil de privilèges'),
			width: 800,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#permissionProfileForm").submit();
					}
				}
			],
			callback	: function(){PermissionProfile.preparePermissionProfileForm();}
		};

		MyWindow.load("prefsAccount", {action:"permissionProfileForm", permprofileid: permprofileid, duplicate:duplicate}, options);
	},

	preparePermissionProfileForm: function(){

		var formId = "permissionProfileForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, formId);
			if (formIsOk){
				Utils.reload();
			}

		}, dataType:"json"};
		MyForm.prepare(formId, "prefsAccount&action=permissionProfileFormRecord", options, true);
		MyFacture.initEvent();

		$('#permissionProfileForm #pprofile_permissions_level').change(function(){

			switch ($(this).val()){
				case 'admin':
					$('#permissionProfileForm tr, #permissionProfileForm h3').not('.category_level, .category_dashboards').hide();
					break;
				case "staff":
					$('#permissionProfileForm tr, #permissionProfileForm h3').show();
					break;
			}

		});

		Qtip.init();
		$('#permissionProfileForm select').trigger('change');
		$('#permissionProfileForm input').trigger('change');


	},

	profileFormCheckReferer: function(me){

		var form = $('#permissionProfileForm');

		var check = false;
		var name = me.data('name');
		var referer = me.data('referer');

		switch (me.prop('tagName')){
			case "INPUT":
				check = !me.is(':checked');
				break;
			case "SELECT":
				check = me.val() == "none";
				break;

		}

		if (check){

			form.find('select[data-referer='+name+'] option[value=none]').prop('selected',true).trigger('change');
			form.find('select[data-referer='+name+'][multiple=true] ').multipleSelect("uncheckAll").multipleSelect("disable");
			form.find('[data-referer='+name+']:checkbox').prop('checked', false);
			form.find('[data-referer='+name+']').attr('disabled','disabled');


		} else {
			form.find('[data-referer='+name+']').not('[data-referer-values]').removeAttr('disabled');
			form.find('[data-referer='+name+'][data-referer-values*='+ me.val() +']').removeAttr('disabled');
			form.find('[data-referer='+name+'][data-referer-values]').not('[data-referer-values*='+ me.val() +']').attr('disabled', 'disabled');
			form.find('select[data-referer='+name+'][multiple=true] ').multipleSelect("enable");
		}


	},

}

window.PrefsStaffPermissionsTable = {

	toggleStaff : function(view){

		var column = $('#userPrivilegesTable').DataTable().column( view.value);
        column.visible( ! column.visible() );

	},

	init : function(){

		Qtip.init();

		var table = $('#userPrivilegesTable').DataTable( {
			scrollY			: '60vh',
			scrollX			: true,
			scrollCollapse	: true,
			paging			: false,
			searching		: false,
			ordering		: false,
			info			: false,
			order			: [],
			stripeClasses	: [],
			language:		{	search: Loc.g('Chercher un privilège :')},
			initComplete: function(settings, json) {
				$('#userPrivilegesTable').DataTable().columns.adjust().draw();
			}
		} );

	}

}

window.PrefsEmail = {
    /**
     * Confirm logout email account
     */
    logout: function()
    {
        var options = {
            title: false,
            dialogClass: 'popup-white',
			callback: function() {
				PrefsEmail.prepareLogoutForm();
			}
        };
        MyWindow.load('prefsNylas', {action: 'logoutConfirm'}, options);
    },

    /**
     * Switch type account (staff/corp)
     * @param string type
     */
    switchAccount: function(type)
    {
        var options = {
            title: false,
            dialogClass: 'popup-white'
        };
        MyWindow.load('prefsNylas', {action: 'switchAccountConfirm', type: type}, options);
    },

	prepareLogoutForm: function()
	{
		var formId = "emailLogoutForm";
		var options = {
			success:function(data){
				var formIsOk = MyForm.processJson(data, formId);
				if(formIsOk){
					if (data.form.fields.find(field => field.isEmailEngineEnabled === true)) {
						Utils.reload();
					} else {
						Utils.relocate('?_f=emailPreferences&action=emailsParams&popup=logout');
					}
				}
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "prefsNylas&action=logout", options, true);
	},

    /**
	 * Toggle btn in prefs email modal
     * @param object item
     */
    toggleConfirm: function(item)
    {
        var btn = $(item).parent().next();
        if ($(item).is(':checked')) {
            btn.removeClass('btn-disabled');
            btn.prop("disabled", false);
			if (btn.is('[data-href]')) {
				btn.attr('href', btn.attr('data-href'));
			}

        } else {
            btn.addClass('btn-disabled');
            btn.prop("disabled", true);
			btn.removeAttr('href');
        }
    }
};
